export default __webpack_public_path__ + "static/media/plt_logo.8ab8e272.png";